exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#PrivacyAgreement {\n  padding: 0.16rem;\n  font-size: 0.15rem;\n  color: #1e283c;\n  width: 100%;\n}\n#PrivacyAgreement .dataTime {\n  text-align: right;\n  font-size: 0.12rem;\n}\n#PrivacyAgreement h2 {\n  font-size: 0.18rem;\n}\n#PrivacyAgreement h3 {\n  margin: 0.05rem 0;\n  font-size: 0.15rem;\n}\n#PrivacyAgreement section {\n  margin: 0.12rem 0;\n  width: 100%;\n}\n#PrivacyAgreement .table1 {\n  width: 800px;\n  display: table;\n  border-collapse: collapse;\n}\n#PrivacyAgreement .table1 .table-view {\n  display: table-row;\n}\n#PrivacyAgreement .table1 .table-view .table-clumn {\n  width: 10%;\n  display: table-cell;\n  word-wrap: break-word;\n  overflow: hidden;\n  vertical-align: middle;\n  border: 1px solid #333;\n  word-break: break-all;\n}\n#PrivacyAgreement .scorll-view {\n  overflow-x: auto;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/privacyAgreement/index.less
// module id = 335
// module chunks = 0